module.exports = __webpack_public_path__ + "static/media/Mobile-Tabletop.1115353d.jpg";